import React from 'react';
import { Globe2, Users, Book, Award, Clock, CheckCircle } from 'lucide-react';

const FreeProgram = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div style={{ backgroundColor: '#751fab' }} className="min-h-screen">
        <div className="container mx-auto px-4 pt-12 pb-4">
          <div className="text-center">
            <img 
              src="/logofncflor.png"
              alt="Nueva Consciencia Logo"
              className="w-[200px] h-[110px] mx-auto mb-4"
            />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
              PROGRAMA DE FORMACIÓN CONTINUA GRATUITA
            </h1>
            <p className="text-xl md:text-2xl text-white mb-12">
              Más de 500 cursos gratuitos. Más de 2 millones de vidas transformadas. Y tú puedes ser la siguiente.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <Book className="w-12 h-12 text-white mx-auto mb-4" />
                <div className="text-3xl font-bold text-white">500+</div>
                <div className="text-white">Cursos gratuitos</div>
              </div>
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <Users className="w-12 h-12 text-white mx-auto mb-4" />
                <div className="text-3xl font-bold text-white">2Mill+</div>
                <div className="text-white">Vidas transformadas</div>
              </div>
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <Globe2 className="w-12 h-12 text-white mx-auto mb-4" />
                <div className="text-3xl font-bold text-white">8</div>
                <div className="text-white">Países con operaciones</div>
              </div>
            </div>
            <a href="https://fundacionnuevaconsciencia.com/thank_you/taranis/bienvenido-dr-taranis.php" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors">
              Suscríbete ahora
            </a>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="bg-white pt-4 pb-16 px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Fundación Nueva Conciencia es la escuela de metafísica y crecimiento personal de mayor impacto en habla hispana. Con operaciones en 8 países — Estados Unidos, México, Colombia, Chile, Argentina, Ecuador, Bolivia y Perú — cada semana abrimos las puertas del conocimiento a entre 10,000 y 15,000 estudiantes que, desde la comodidad de su hogar, acceden a formación de primer nivel en temas que transforman vidas.
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Nuestro programa de formación gratuita cuenta con más de 500 cursos en vivo sobre desarrollo personal, abarcando disciplinas como <strong>Hipnosis, Reiki Usui Amplificado, Reiki Karuna, Poderes Mentales, Sanación Energética, Meditación, Leyes del Éxito, Salud Alternativa, Constelaciones Familiares, Metafísica aplicada</strong> y mucho más.
            </p>
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ backgroundColor: '#751fab' }} className="py-16 px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
              ¿Cómo funciona?
            </h2>
            <p className="text-xl text-white mb-8 leading-relaxed">
              Es muy sencillo. Al suscribirte, se te asigna un instructor y un profesor de entre nuestra plantilla de especialistas repartidos por todo el mundo. Cada instructor ofrece de 3 a 5 cursos gratuitos por semana, según su área de experiencia. Recibirás en tu grupo los accesos a los eventos en vivo programados, y cada semana se renueva la programación con nuevos contenidos.
            </p>
            <p className="text-xl text-white mb-8 leading-relaxed">
              Cada evento tiene una duración de entre 1 y 4 horas, con contenidos extraordinarios y herramientas prácticas que puedes aplicar en tu vida de inmediato. Además, puedes tomar cursos con diversos instructores cada semana, ampliando tu conocimiento en múltiples áreas.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <CheckCircle className="w-8 h-8 text-white mx-auto mb-2" />
                <p className="text-white font-semibold">Todo en vivo</p>
              </div>
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <CheckCircle className="w-8 h-8 text-white mx-auto mb-2" />
                <p className="text-white font-semibold">Todo online</p>
              </div>
              <div style={{ backgroundColor: '#ad4bed' }} className="rounded-lg p-6">
                <CheckCircle className="w-8 h-8 text-white mx-auto mb-2" />
                <p className="text-white font-semibold">Todo sin salir de casa</p>
              </div>
            </div>
            <a href="https://fundacionnuevaconsciencia.com/thank_you/taranis/bienvenido-dr-taranis.php" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors">
              Suscríbete ahora
            </a>
          </div>
        </div>
      </div>

      {/* Why trust us */}
      <div className="bg-white py-16 px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-[#751fab] mb-8 text-center">
              ¿Por qué más de 2 millones de personas han confiado en nosotros?
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Porque nuestros cursos impactan la vida de las personas de forma tan positiva que los alumnos suelen quedarse por meses y años tomando diferentes formaciones. Porque no solo enseñamos teoría: revelamos los secretos de la metafísica y cómo aplicarlos concretamente para que puedas conquistar tus objetivos personales, resolver situaciones que quizás llevas años cargando, o simplemente alcanzar un mayor estado de plenitud.
            </p>
            <div className="bg-[#751fab]/5 rounded-xl p-8 mb-8">
              <div className="flex items-start gap-4">
                <Award className="w-12 h-12 text-[#751fab] flex-shrink-0" />
                <p className="text-xl text-gray-600">
                  Al finalizar cada curso recibes tu <strong>certificado como terapeuta</strong>, con reconocimiento del <strong>Seminario de Cultura y Paz de Naciones Unidas (ONU)</strong>, junto con material de apoyo — audios, PDFs y videos — para que puedas continuar tu práctica.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{ backgroundColor: '#751fab' }} className="py-16 px-4">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Permítenos ayudarte a liberar todo tu potencial.
            </h2>
            <p className="text-xl text-white mb-8 leading-relaxed">
              La Fundación está aquí para enseñarte un cúmulo de herramientas prácticas, para acompañarte en tu camino de evolución y para ayudarte a encontrar ese gigante interior que puede transformar tu realidad para muchísimo mejor.
            </p>
            <p className="text-2xl text-white font-semibold mb-8">
              Suscríbete ahora y recibe tu invitación al próximo evento en vivo este fin de semana.
            </p>
            <a href="https://fundacionnuevaconsciencia.com/thank_you/taranis/bienvenido-dr-taranis.php" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-[#751fab] font-bold py-4 px-8 rounded-full text-lg hover:bg-purple-50 transition-colors">
              Suscríbete ahora
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeProgram;
